import React, { Fragment, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg';
import heroImage from '../../images/hero-registration.jpg';
import consentPdf from '../../Consent for use of regenerative treatment.pdf';
import questionnairePdf from '../../Medical questionnaire.pdf';
import './PatientFormsPage.css';

const PatientFormsPage = () => {
    const [loadedPreviews, setLoadedPreviews] = useState({});

    const pdfDocuments = [
        {
            title: 'Consent for Use of Regenerative Treatment',
            description: 'Complete consent form for stem cell and regenerative therapy procedures',
            file: consentPdf,
            id: 'consent-form'
        },
        {
            title: 'Medical Questionnaire',
            description: 'Comprehensive medical history and health assessment form',
            file: questionnairePdf,
            id: 'medical-form'
        }
    ];

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <div className="wpo-breadcumb-area patient-forms-hero">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="wpo-breadcumb-wrap">
                                <h2>Patient Forms & Documentation</h2>
                                <ul>
                                    <li><a href="/home">Home</a></li>
                                    <li>Patient Forms</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="patient-forms-intro section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="section-title text-center">
                                <h2>Complete Your Registration Process</h2>
                                <p className="subtitle">
                                    Complete your registration process with our comprehensive patient forms 
                                    and learn about Florida's advanced stem cell therapy legislation
                                </p>
                            </div>
                            <div className="legislation-banner" style={{
                                background: 'linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%)',
                                border: '2px solid #0066cc',
                                borderRadius: '10px',
                                padding: '25px',
                                marginTop: '30px',
                                textAlign: 'center',
                                boxShadow: '0 4px 6px rgba(0,102,204,0.1)'
                            }}>
                                <h3 style={{color: '#003366', marginBottom: '15px', fontSize: '24px'}}>
                                    Florida Senate Bill 1768
                                </h3>
                                <p style={{color: '#555', marginBottom: '20px', fontSize: '16px'}}>
                                    Stem cell therapy is legally authorized in Florida. Our treatments are fully compliant with state regulations.
                                </p>
                                <a 
                                    href="https://www.flsenate.gov/Session/Bill/2025/1768/?Tab=BillText" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn btn-primary"
                                    style={{
                                        background: '#0066cc',
                                        border: 'none',
                                        padding: '12px 30px',
                                        fontSize: '16px',
                                        fontWeight: '600'
                                    }}
                                >
                                    View Official Legislation
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="patient-forms-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="forms-grid">
                                {pdfDocuments.map((doc, index) => (
                                    <div key={index} className="form-card">
                                        <div className="pdf-preview-container">
                                            <div className="pdf-icon">
                                                <i className="fi flaticon-document"></i>
                                                <span className="pdf-label">PDF</span>
                                            </div>
                                            <div className={`pdf-preview-wrapper ${doc.id === 'medical-form' ? 'scrollable' : ''}`}>
                                                <iframe
                                                    src={`${doc.file}#toolbar=0&navpanes=0`}
                                                    className="pdf-preview-frame"
                                                    title={doc.title}
                                                    onLoad={() => setLoadedPreviews(prev => ({ ...prev, [doc.id]: true }))}
                                                />
                                                {!loadedPreviews[doc.id] && (
                                                    <div className="pdf-loading">
                                                        <div className="spinner"></div>
                                                        <p>Loading preview...</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-details">
                                            <h3>{doc.title}</h3>
                                            <p>{doc.description}</p>
                                            <div className="form-actions">
                                                <a 
                                                    href={doc.file} 
                                                    className="btn btn-primary"
                                                    download
                                                >
                                                    <i className="fi flaticon-download"></i>
                                                    Download Form
                                                </a>
                                                <a 
                                                    href={doc.file} 
                                                    className="btn btn-outline"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <i className="fi flaticon-view"></i>
                                                    View Form
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="forms-info-section">
                                <h3>Important Information</h3>
                                <div className="info-grid">
                                    <div className="info-item">
                                        <i className="fi flaticon-check"></i>
                                        <div>
                                            <h4>Complete All Forms</h4>
                                            <p>Please complete all required forms before your appointment to expedite your visit.</p>
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <i className="fi flaticon-security"></i>
                                        <div>
                                            <h4>HIPAA Compliant</h4>
                                            <p>All patient information is handled in strict accordance with HIPAA regulations.</p>
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <i className="fi flaticon-medical"></i>
                                        <div>
                                            <h4>Florida Legislation</h4>
                                            <p>Our treatments comply with Florida's progressive stem cell therapy legislation and medical guidelines as authorized by <a href="https://www.flsenate.gov/Session/Bill/2025/1768/?Tab=BillText" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline', color: '#0066cc'}}>Senate Bill 1768</a>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    );
};

export default PatientFormsPage;